import { Drawer, DialogContent } from "@mui/material"
import React, { ReactNode } from "react"
import DialogTitle from "./DialogTitle"

export interface DrawerProps {
  onClose: () => void
  title: string
  open: boolean
  children: ReactNode
}

const CustomDrawer = ({ onClose, title, open, children }: DrawerProps) => {
  return (
    <Drawer open={open} onClose={onClose} anchor="bottom">
      <DialogTitle variant="h5" onClose={onClose}>
        {title}
      </DialogTitle>
      <DialogContent>{children}</DialogContent>
    </Drawer>
  )
}

export default CustomDrawer
